<template>
  <div>
    <v-list>
      <v-list-tile @click.stop="navigateTo(defaultCalendarRouteName)">
        <v-list-tile-action>
          <v-icon>calendar_today</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Calendar
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click.stop="navigateTo('timeclockShiftConfirm')">
        <v-list-tile-action>
          <v-icon>schedule</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
            Time Clock
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click.stop="navigateTo('employeeOwnWorkHistory')">
        <v-list-tile-action>
          <v-icon>table_chart</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
            Work History
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click.stop="navigateTo('resources')">
        <v-list-tile-action>
          <v-icon>library_books</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Resources
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('userAuth', [
      'user',
      'token'
    ]),
    ...mapGetters('userAuth', [
      'isLoggedIn',
      'defaultCalendarRouteName'
    ])
  },
  methods: {
  }
}
</script>

<style scoped>
  #sidebar a {
    color: black;
    text-decoration: none;
  }
</style>
